/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LanguageCode,
    LanguageCodeFromJSON,
    LanguageCodeFromJSONTyped,
    LanguageCodeToJSON,
} from './LanguageCode';

/**
 * 
 * @export
 * @interface UpdateLanguageCommand
 */
export interface UpdateLanguageCommand {
    /**
     * 
     * @type {LanguageCode}
     * @memberof UpdateLanguageCommand
     */
    languageCode?: LanguageCode;
}

export function UpdateLanguageCommandFromJSON(json: any): UpdateLanguageCommand {
    return UpdateLanguageCommandFromJSONTyped(json, false);
}

export function UpdateLanguageCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLanguageCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'languageCode': !exists(json, 'languageCode') ? undefined : LanguageCodeFromJSON(json['languageCode']),
    };
}

export function UpdateLanguageCommandToJSON(value?: UpdateLanguageCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'languageCode': LanguageCodeToJSON(value.languageCode),
    };
}

